<template>
  <div>
    <sidebar-item
      v-for="route in allowedRoutes"
      :key="route.name"
      :link="{name: route.title,
      path: route.path, icon: route.icon, customIcon: route.customIcon,
      disabled: route.notAllowedRoute }"
    >
      <sidebar-item
        v-for="croute in route.children"
        :key="croute.path"
        :link="{name: croute.title, path: croute.path, disabled: croute.notAllowedRoute }"
      ></sidebar-item>
    </sidebar-item>
  </div>
</template>

<script>
import usesAccountInfoMixin from "@/mixins/usesAccountInfo";
import { mapGetters } from "vuex";

const DEBUG = process.env.NODE_ENV !== "production";

const permissionsMapMaker = function (routes) {
  let permissionsMap = {};

  for (const route of routes) {
    const routeKey = `${route.name}$${route.path}`;
    const pMap = {};
    const allowed = {};
    const denied = {};

    const roles = route.roles || [];
    const excludedRoles = route.excludedRoles || [];
    const areas = route.areas || [];

    for (const role of roles) {
      allowed[`role/${role}`] = true;
    }

    for (const role of excludedRoles) {
      denied[`role/${role}`] = true;
    }

    for (const area of areas) {
      allowed[`area/${area}`] = true;
    }

    if (!!Object.keys(allowed).length) {
      pMap.allowed = allowed;
    }

    if (!!Object.keys(denied).length) {
      pMap.denied = denied;
    }

    if (!!Object.keys(pMap).length) {
      permissionsMap[routeKey] = pMap;
    }

    const children = route.children;
    if (children) {
      const childrenMap = permissionsMapMaker(children);
      permissionsMap = { ...permissionsMap, ...childrenMap };
    }
  }

  return permissionsMap;
};

export default {
  mixins: [usesAccountInfoMixin],
  data() {
    return {
      default_icon: "web_asset",
    };
  },
  methods: {
    allowedRoute(route) {
      const routePMap = this.permissionsMap[`${route.name}$${route.path}`];

      if (!route.title || typeof route.title !== "string") {
        return false;
      } else if (!routePMap || this.userIsAdmin) {
        return true;
      }

      const userRole = `role/${this.userRole}`;
      const userArea = `area/${this.account.userArea}`;

      const { denied: deniedMap, allowed: allowedMap } = routePMap;

      if (deniedMap && deniedMap[userRole]) {
        return false;
      }

      if (allowedMap) {
        const areaAllowed = allowedMap[userArea];
        const userAllowed = allowedMap[userRole];

        return areaAllowed || userAllowed;
      }

      return true;
    },

    allowedChildren(childrens) {
      if (!childrens) return [];
      return childrens.filter(this.allowedRoute);
    },
    filterAccountPermissions(routes = []) {
      const { passedPerm, routeCheckPerm } = this;
      let filteredRoutes = routes.filter(
        ({ meta }) => !meta.ifCan || passedPerm(meta.ifCan)
      );
      if (!DEBUG) {
        filteredRoutes = filteredRoutes.filter(
          ({ meta: { ifUserCan } }) => !ifUserCan || routeCheckPerm(ifUserCan)
        );
      } else {
        filteredRoutes = filteredRoutes
          .map((route) => ({ ...route, notAllowedRoute: true }))
          .map((route) => {
            const {
              meta: { ifUserCan },
            } = route;
            return {
              ...route,
              notAllowedRoute: !(!ifUserCan || routeCheckPerm(ifUserCan)),
            };
          });
      }
      return filteredRoutes;
    },
    passedPerm(permObj) {
      const { userCan } = this;
      const tests = Object.entries(permObj).map(([permission, resource]) =>
        userCan(permission, resource)
      );
      return tests.every((v) => !!v);
    },
    routeCheckPerm(permObj) {
      const { userAccountCan } = this;
      const tests = Object.entries(permObj).map(([permission, entry]) => {
        let appModels = entry;
        if (!Array.isArray(appModels)) {
          appModels = [appModels];
        }

        appModels = appModels.map((s) => s.split("/"));
        return appModels.every(([app, model]) =>
          userAccountCan(permission, app, model)
        );
      });
      return tests.every((v) => !!v);
    },
  },

  computed: {
    allowedRoutes() {
      return this.filterAccountPermissions(this.routes)
        .filter(this.allowedRoute)
        .map((route) => ({
          ...route,
          children: this.filterAccountPermissions(
            this.allowedChildren(route.children)
          ),
        }))
        .filter(({ children }) => !children || children.length);
    },

    permissionsMap() {
      const obj = {};
      const routes = this.routes;

      return permissionsMapMaker(routes);
    },

    routes: function () {
      var routes = [];
      for (var i in this.$router.options.routes) {
        if (!this.$router.options.routes.hasOwnProperty(i)) {
          continue;
        }
        var route = this.$router.options.routes[i];
        if (route.hasOwnProperty("title")) {
          routes.push(route);
        }
      }
      return routes;
    },
    ...mapGetters({
      userCan: "account/userCan",
      userAccountCan: "account/userAccountCan",
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Routing.vue